// extracted by mini-css-extract-plugin
export var capabilities__list = "capabilities-module--capabilities__list--+50DY";
export var capabilities__list_size_small = "capabilities-module--capabilities__list_size_small--EbRa1";
export var capabilities__itemIcon = "capabilities-module--capabilities__item-icon--kfrCI";
export var capabilities__itemTitle = "capabilities-module--capabilities__item-title--vBrN-";
export var capabilities__itemDesc = "capabilities-module--capabilities__item-desc--ZAIdd";